import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React, { forwardRef } from 'react';
import NotificationIcon from '@atlaskit/icon/glyph/notification';
import { BadgeContainer, NOTIFICATIONS_BADGE_ID } from '../BadgeContainer';
import { IconButton } from '../IconButton';
export var Notifications = /*#__PURE__*/forwardRef(function (props, ref) {
  var badge = props.badge,
      tooltip = props.tooltip,
      iconButtonProps = _objectWithoutProperties(props, ["badge", "tooltip"]);

  return /*#__PURE__*/React.createElement(BadgeContainer, {
    badge: badge
  }, /*#__PURE__*/React.createElement(IconButton, _extends({
    icon: /*#__PURE__*/React.createElement(NotificationIcon, {
      label: typeof tooltip === 'string' ? tooltip : 'Notification Icon'
    }),
    tooltip: tooltip,
    ref: ref,
    "aria-describedby": NOTIFICATIONS_BADGE_ID
  }, iconButtonProps)));
});
export default Notifications;